const smoothScrollTo = (selector, stickyHeader) => {
    const element = document.querySelector(selector);
    window.scroll({
        behavior: 'smooth',
        left: 0,
        top: element.offsetTop - stickyHeader.offsetHeight
    });
};

const updateActiveScrollPosition = debounce((stickyHeader) => {
    const scrollablePanels = document.querySelectorAll('[data-scrollable-panel]');

    scrollablePanels.forEach((panel) => {
        const panelOffset = panel.offsetTop - stickyHeader.offsetHeight;
        const state = window.scrollY >= panelOffset &&
            window.scrollY < (panelOffset + panel.offsetHeight);

        document.querySelector(`#${panel.id}Tab`)
            .classList.toggle('active', state);
    });
}, 50);

const contentNavigation = () => {
    const scrollableNavs = document.querySelectorAll('.scrollable-nav');
    const stickyHeader = document.querySelector('[data-tab-bar]');
    $(document).on('click', '.scrollable-nav', function() {
        let attr = $(this).attr('data-selector');
        if (attr != '' || attr != null) {
            $('html, body').animate({
                scrollTop: $(attr).offset().top - 65
            }, 'slow');
        }
    });
    if (!scrollableNavs.length || !stickyHeader) {
        return;
    }
    scrollableNavs.forEach(el =>
        el.addEventListener('click', () => smoothScrollTo(el.dataset.selector, stickyHeader))
    );
    const init = () => updateActiveScrollPosition(stickyHeader);
    window.addEventListener('scroll', init);
    window.addEventListener('resize', init);
    init();
};

export default contentNavigation;
